var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3H0.749996C0.339996 3 -3.8147e-06 3.34 -3.8147e-06 3.75V17.25C-3.8147e-06 17.66 0.339996 18 0.749996 18H17.25C17.66 18 18 17.66 18 17.25V3.75C18 3.34 17.66 3 17.25 3ZM16.5 4.5V7.5H1.5V4.5H16.5ZM1.5 16.5V9H16.5V16.5H1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.25C3 5.66 3.34 6 3.75 6C4.16 6 4.5 5.66 4.5 5.25V0.75C4.5 0.34 4.16 0 3.75 0C3.34 0 3 0.34 3 0.75V5.25Z",
    fill: "currentColor",
    className: "accent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.25C13.5 5.66 13.84 6 14.25 6C14.66 6 15 5.66 15 5.25V0.75C15 0.34 14.66 0 14.25 0C13.84 0 13.5 0.34 13.5 0.75V5.25Z",
    fill: "currentColor",
    className: "accent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12C3.34 12 3 11.66 3 11.25C3 10.84 3.34 10.5 3.75 10.5H5.25C5.66 10.5 6 10.84 6 11.25C6 11.66 5.66 12 5.25 12H3.75Z",
    fill: "currentColor",
    className: "accent"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12H9.75C10.16 12 10.5 11.66 10.5 11.25C10.5 10.84 10.16 10.5 9.75 10.5H8.25C7.84 10.5 7.5 10.84 7.5 11.25C7.5 11.66 7.84 12 8.25 12Z",
    fill: "currentColor",
    className: "accent"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12C12.34 12 12 11.66 12 11.25C12 10.84 12.34 10.5 12.75 10.5H14.25C14.66 10.5 15 10.84 15 11.25C15 11.66 14.66 12 14.25 12H12.75Z",
    fill: "currentColor",
    className: "accent"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.25C3 14.66 3.34 15 3.75 15H5.25C5.66 15 6 14.66 6 14.25C6 13.84 5.66 13.5 5.25 13.5H3.75C3.34 13.5 3 13.84 3 14.25Z",
    fill: "currentColor",
    className: "accent"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15H8.25C7.84 15 7.5 14.66 7.5 14.25C7.5 13.84 7.84 13.5 8.25 13.5H9.75C10.16 13.5 10.5 13.84 10.5 14.25C10.5 14.66 10.16 15 9.75 15Z",
    fill: "currentColor",
    className: "accent"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25C12 14.66 12.34 15 12.75 15H14.25C14.66 15 15 14.66 15 14.25C15 13.84 14.66 13.5 14.25 13.5H12.75C12.34 13.5 12 13.84 12 14.25Z",
    fill: "currentColor",
    className: "accent"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e35a1b8582d75b1deb4007d6adcd04e1.svg";
export { ForwardRef as ReactComponent };